import BaseSensorExtension from '../base-sensor';
import formatMessage from 'format-message';

class OLEDDisplayExtension extends BaseSensorExtension {
    constructor (runtime) {
        super(runtime);
    }

    getSensorInfo () {
        return {
            id: 'oledDisplay',
            name: 'OLED Display',
            color1: '#00B0FF',
            color2: '#0091EA',
            color3: '#01579B',

            blocks: [
                {
                    opcode: 'oled_init',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'oledDisplay.blocks.init',
                        default: 'initialize OLED display I2C address [ADDRESS] width [WIDTH] height [HEIGHT]'
                    }),
                    arguments: {
                        ADDRESS: {
                            type: 'string',
                            defaultValue: '0x3C'
                        },
                        WIDTH: {
                            type: 'number',
                            defaultValue: '128'
                        },
                        HEIGHT: {
                            type: 'number',
                            defaultValue: '64'
                        }
                    }
                },
                {
                    opcode: 'oled_clear',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'oledDisplay.blocks.clear',
                        default: 'clear OLED display'
                    })
                },
                {
                    opcode: 'oled_print',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'oledDisplay.blocks.print',
                        default: 'print [TEXT] at x: [X] y: [Y] on OLED'
                    }),
                    arguments: {
                        TEXT: {
                            type: 'string',
                            defaultValue: 'Hello!'
                        },
                        X: {
                            type: 'number',
                            defaultValue: '0'
                        },
                        Y: {
                            type: 'number',
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'oled_show',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'oledDisplay.blocks.show',
                        default: 'update OLED display'
                    })
                }
            ],

            menus: {},

            codeTemplates: [
                {
                    opcode: 'oled_init',
                    type: 'command',
                    arduino: {
                        code: 'display.begin(SSD1306_SWITCHCAPVCC, {{ADDRESS}});',
                        setup: [
                            'display.begin(SSD1306_SWITCHCAPVCC, {{ADDRESS}});',
                            'display.clearDisplay();',
                            'display.setTextColor(WHITE);'
                        ],
                        includes: ['#include <Wire.h>', '#include <Adafruit_GFX.h>', '#include <Adafruit_SSD1306.h>'],
                        declarations: [
                            '#define SCREEN_WIDTH {{WIDTH}}',
                            '#define SCREEN_HEIGHT {{HEIGHT}}',
                            'Adafruit_SSD1306 display(SCREEN_WIDTH, SCREEN_HEIGHT, &Wire, -1);'
                        ]
                    },
                    python: {
                        code: '',
                        setup: [
                            'i2c = I2C(scl=Pin(5), sda=Pin(4))',
                            'oled = ssd1306.SSD1306_I2C({{WIDTH}}, {{HEIGHT}}, i2c, addr=int({{ADDRESS}}, 16))'
                        ],
                        imports: ['from machine import Pin, I2C', 'import ssd1306']
                    }
                },
                {
                    opcode: 'oled_clear',
                    type: 'command',
                    arduino: {
                        code: 'display.clearDisplay();',
                        setup: [],
                        includes: []
                    },
                    python: {
                        code: 'oled.fill(0)\noled.show()',
                        setup: [],
                        imports: []
                    }
                },
                {
                    opcode: 'oled_print',
                    type: 'command',
                    arduino: {
                        code: 'display.setCursor({{X}}, {{Y}});\ndisplay.print({{TEXT}});',
                        setup: [],
                        includes: []
                    },
                    python: {
                        code: 'oled.text(str({{TEXT}}), {{X}}, {{Y}})\noled.show()',
                        setup: [],
                        imports: []
                    }
                },
                {
                    opcode: 'oled_show',
                    type: 'command',
                    arduino: {
                        code: 'display.display();',
                        setup: [],
                        includes: []
                    },
                    python: {
                        code: 'oled.show()',
                        setup: [],
                        imports: []
                    }
                }
            ]
        };
    }

    oled_init (args) {
        return Promise.resolve();
    }

    oled_clear (args) {
        return Promise.resolve();
    }

    oled_print (args) {
        return Promise.resolve();
    }

    oled_show (args) {
        return Promise.resolve();
    }
}

export default OLEDDisplayExtension;
